import {ModuleWithProviders, NgModule} from "@angular/core";
import {PermissionDirective} from "../../directives/permission.directive";
import {RemoveIfFeatureFlagOffDirective} from "../../directives/remove-if-feature-flag-off.directive";
import {PreventScrollNumInputDirective} from "../../directives/prevent-scroll-num-input.directive";
import {AutoLogoutComponent} from "../components/auto-logout/auto-logout.component";
import {NgxFileSaverService} from "@clemox/ngx-file-saver";
import {RouterModule} from "@angular/router";


@NgModule({
    declarations: [
    ],
    imports: [
        PermissionDirective,
        RemoveIfFeatureFlagOffDirective,
        PreventScrollNumInputDirective,        
        AutoLogoutComponent,
    ],
    exports: [
        PermissionDirective,
        RemoveIfFeatureFlagOffDirective,
        PreventScrollNumInputDirective,
        AutoLogoutComponent,
        RouterModule
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                NgxFileSaverService
            ]
        }
    }
}
